var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{attrs:{"type":"range","max":_vm.max,"min":_vm.min},domProps:{"value":_vm.value},on:{"change":function($event){return _vm.change($event.target.value)}}})}
var staticRenderFns = []

export { render, staticRenderFns }